<div *ngIf="!getSessionExpired" class="col-12">
    <div class="card-body" *ngIf="analytics.TransactionCount > 0; else noTransactions">
        <h2 class="card-title" style="text-align: center;">Вашите финансови анализи за текущия месец</h2>
        <div class="col-lg-4 col-lg-offset-6 col-centered pt-3 mb-5">
            <form [formGroup]="form" (ngSubmit)="changeSelection()">
                <div class="input-group mb-3">
                    <select formControlName="selection" class="form-control">
                        <option value="spending">Трансакции</option>
                        <option value="transactions">Тип трансакции</option>
                    </select>
                </div>
                <div class="input-group-btn d-flex justify-content-center">
                    <button type="submit" class="btn btn-primary">Опресни графиката</button>
                </div>
            </form>
        </div>
        <div class="statistics col-12">
            <div class="row">
                <div class="col-12 col-md-6 p-5">
                    <canvas mdbChart id="pieChart" *ngIf="chartData.length != 0" [chartType]="chartType"
                        [data]="chartData" [labels]="chartLabels" [colors]="chartColors" [options]="chartOptions"
                        [legend]="true">
                    </canvas>
                </div>
                <div class="col-12 col-md-6 p-5">
                    <canvas mdbChart id="doughnutChart" *ngIf="chartData.length != 0" [chartType]="'doughnut'"
                        [data]="chartData" [labels]="chartLabels" [colors]="chartColors" [options]="chartOptions"
                        [legend]="true">
                    </canvas>
                </div>
                <div class="col-12 col-md-6 p-5">
                    <canvas mdbChart id="barChart" *ngIf="chartData.length != 0" [chartType]="'bar'" [data]="chartData"
                        [labels]="chartLabels" [colors]="chartColors" [options]="chartOptions" [legend]="true">
                    </canvas>
                </div>
                <div class="col-12 col-md-6 p-5">
                    <canvas mdbChart id="lineChart" *ngIf="chartData.length != 0" [chartType]="'line'"
                        [data]="chartData" [labels]="chartLabels" [colors]="chartColors" [options]="chartOptions"
                        [legend]="true">
                    </canvas>
                </div>
            </div>
        </div>
        <div style="text-align: center;" class="col-lg-6 col-lg-offset-6 col-centered pt-3">
            <h5 *ngIf="chartSelection =='transactions'">Вашият най-често срещан тип трансакция е
                "{{analytics.MostCommonTransactionType}}"!</h5>
            <h5 *ngIf="chartSelection == 'spending'">
                Най-голямата Ви трансакция е {{analytics.BiggestTransactionByAmount.AmountSpent}} лв. в категория
                "{{analytics.BiggestTransactionByAmount.Type}}"
            </h5>
        </div>
        <div class="col col-12 col-centered">
            <table class="table table-striped mt-5">
                <thead>
                    <tr>
                        <th scope="col">Категория</th>
                        <th scope="col">Брой трансакции</th>
                        <th scope="col">Сума</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let demographic of analytics.Demographics">
                        <th style="text-transform: capitalize;">{{demographic.Type}}</th>
                        <td>{{demographic.NumberOfTransaction}}</td>
                        <td>{{demographic.MoneySpent}} лв.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<ng-template #noTransactions>
    <app-no-data class="center"></app-no-data>
</ng-template>

<app-calculator></app-calculator>

<footer>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h3>За нас</h3>
                <p>Ние от MYLEV сме екип от професионалисти в областта на финансите, които вярват, че всеки заслужава да
                    има
                    контрол върху своите финанси. С нашата приложна програма може да проследите разходите си, да
                    получите подробна
                    информация за финансовото си състояние и да управлявате сметките си докато сте в движение.</p>
            </div>
            <div class="col-md-3">
                <h3>За връзка</h3>
                <ul>
                    <li>Димитър Найденов 100</li>
                    <li>Велико Търново, България</li>
                    <li>Email: info@mylev.com</li>
                </ul>
            </div>
            <div class="col-md-3">
                <h3>Последвайте ни в</h3>
                <ul>
                    <li><a href="#">Facebook</a></li>
                    <li><a href="#">Twitter</a></li>
                    <li><a href="#">Instagram</a></li>
                    <li><a href="#">LinkedIn</a></li>
                </ul>
            </div>
        </div>
        <hr>
        <p>Изработено от <a href="http://temelkov.tk" target="_blank">Станислав Tемелков</a> &copy; MYLEV 2023</p>
    </div>
</footer>